// @ts-nocheck

import { createSelector } from 'reselect';

import { selectEntitiesOutcomes } from '../../selectors/entities/outcomes/entitiesOutcomesPrimary.selector';
import { makeMatchBetsArraySelector } from '../../selectors/match.selector';

const makeMatchBetHotFilterPropsSelector = () => {
  const selectMatchBetsArray = makeMatchBetsArraySelector();

  const selectMatchBetsHotOutcomes = createSelector(
    [selectMatchBetsArray, selectEntitiesOutcomes],
    (matchBets, outcomes) =>
      matchBets.reduce(
        (matchBetsAccumulator, bet) =>
          Array.isArray(bet?.outcomes)
            ? [
                ...matchBetsAccumulator,
                ...bet.outcomes.reduce(
                  (betOutcomesAccumulator, outcomeId) =>
                    outcomes[outcomeId]?.hotUsers ? [...betOutcomesAccumulator, outcomeId] : betOutcomesAccumulator,
                  [],
                ),
              ]
            : matchBetsAccumulator,
        [],
      ),
  );

  const selectNbHotMatchBetsOutcomes = createSelector(
    [selectMatchBetsHotOutcomes],
    (matchBetsHotOutcomes) => matchBetsHotOutcomes.length,
  );

  return createSelector([selectNbHotMatchBetsOutcomes], (nbHotBets) => ({
    nbHotBets,
  }));
};

export default makeMatchBetHotFilterPropsSelector;
